import * as React from 'react'
import { Form } from 'react-bootstrap'
import Ratings from 'react-ratings-declarative'
import { JobWorkerT } from '../../../../types/JobWorker'



interface FeedbackProps {
    updateWorker(key: string, value: any): void
    worker: JobWorkerT
}

const Feedback: React.FunctionComponent<FeedbackProps> = ({ updateWorker, worker }): JSX.Element => {

    const changeRating = (rating: number) => {
        // console.log('rating', rating);
        // worker.rating = rating; 
        updateWorker('rating', rating)
    }
    return (
        <div>
            <h5>Feedback</h5>
            <Ratings
                changeRating={changeRating}
                rating={worker.rating ? worker.rating : 2.5}
                widgetDimensions='30px'
                widgetHoverColors='#f26000'
                widgetRatedColors='#fed8b1'>
                <Ratings.Widget />
                <Ratings.Widget />
                <Ratings.Widget />
                <Ratings.Widget />
                <Ratings.Widget />
            </Ratings>
            <div>
                <Form.Label>Notes</Form.Label>
                <Form.Control
                    as='textarea'
                    className='input-material'
                    rows={2}
                    value={`${worker.notes ? worker.notes : ''}`}
                    onChange={(e: any) => {
                        updateWorker('notes', e.target.value)
                    }}
                />
            </div>
        </div>
    )
}

export default Feedback